import React from 'react';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-react';
import BackToTopButton from '../BackToTopButton/BackToTopButton';

type EULAProps = {
  fields: {
    RichTextField: Field<string>;
  };
};

const EULA = ({ fields }: EULAProps): React.JSX.Element => {
  return (
    <>
      <RichText field={fields.RichTextField} />
      <BackToTopButton />;
    </>
  );
};

export default EULA;
